// Single source of truth for the inbound-emails list sortable columns, shared
// between the route's `validateSearch` schema and the page's table columns so
// the two can't drift out of sync.
export const INBOUND_EMAIL_SORT_COLUMN_IDS = [
  'createdAt',
  'updatedAt',
  'receivedAt',
  'from',
  'to',
  'subject',
  'receivedByMailbox',
  'messageId',
] as const;

export type InboundEmailSortColumnId =
  (typeof INBOUND_EMAIL_SORT_COLUMN_IDS)[number];
